import { CircleNotch, UploadSimple } from "@phosphor-icons/react";
import { Button } from "./ui/button";

export function CsvImportButton({ importing, onSelect }) {
  return (
    <Button
      variant="outline"
      size="sm"
      className="border-border gap-1.5 min-w-[116px]"
      onClick={onSelect}
      disabled={importing}
      aria-busy={importing}
      data-testid="csv-import-btn"
    >
      {importing ? (
        <CircleNotch size={15} className="animate-spin" aria-hidden="true" />
      ) : (
        <UploadSimple size={15} aria-hidden="true" />
      )}
      {importing ? "Importing…" : "Import CSV"}
    </Button>
  );
}

export function CsvImportProgress({ fileName }) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="relative overflow-hidden rounded-lg border border-forecast/35 bg-forecast/5 px-4 py-3"
      data-testid="csv-import-progress"
    >
      <div className="absolute inset-y-0 left-0 w-1 bg-forecast" aria-hidden="true" />
      <div className="flex items-center gap-3 pl-1">
        <CircleNotch size={20} className="shrink-0 animate-spin text-forecast" aria-hidden="true" />
        <div className="min-w-0">
          <p className="truncate text-sm font-semibold">Importing {fileName}</p>
          <p className="text-xs text-muted-foreground">
            Finflo is processing the file. Keep this page open.
          </p>
        </div>
      </div>
    </div>
  );
}
